import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Router } from '@angular/router';
import { Utils } from 'src/app/core/resources/utils';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { VehiclesService } from '../list-vehicles.service';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { Company } from 'src/app/core/interfaces/company';
import { BankAccount } from 'src/app/core/interfaces/userBank';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { FormControl } from '@angular/forms';
import { Patterns } from 'src/app/core/resources/patterns';
import { SelectCompanyComponent } from 'src/app/shared/select-company/select-company.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { ConventionsComponent } from 'src/app/shared/conventions/conventions.component';
import { DateManager } from 'src/app/core/managers/date.manager';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { AccountInscriptionVehicleComponent } from '../account-inscription-vehicle/account-inscription-vehicle.component';
import { SelectableItem } from 'src/app/core/interfaces/selectableItem';
import { FilterModel } from 'src/app/core/models/filter';

@Component({
  selector: 'app-list-vehicles',
  templateUrl: './list-vehicles.component.html',
  styleUrls: ['./list-vehicles.component.scss'],
  providers: [AuthService, PermissionRole]
})

export class ListVehiclesComponent implements OnInit {
  permission = Permission;
  activeSelectItem = false;
  itemsSelecteds: Array<Vehicle> = [];
  freightList: Array<Vehicle> = [];
  typeregister: 'balance' | 'advance';
  optionsFilter: FilterModel[] = [];
  filters: string = '';
  constructor(
    private authService: AuthService,
    public service: VehiclesService,
    public utils: Utils,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private router: Router,
    public permissionRole: PermissionRole,
    private patterns: Patterns,
  ) { }

  /**
  * @description Initializes optionsCompany, resets the paginationlist and executes getVehicles
  */
  ngOnInit() {
    this.optionsFilter = this.service.getOptionsFilter();
  }

  /**
  * @param {string} licencePlate is the value of the filter by license plate
  * @param {string} bankAccountState is the value of the filter by bank account's state
  * @param {boolean} vehicleState is the value of the filter by vehicle's state
  * @description Gets the list of vehicles with filters applied and assigns it into service.paginationList's list
  */
  public getVehicles(filters: string = this.filters, concat: boolean = false): void {
    if (!concat) {
      this.service.paginationList.setList([]);
      this.service.paginationList.setPageKey(1);
      this.service.paginationList.setEnablePagingScroll(false);
    }
    this.filters = filters;
    this.spinner.show();
    this.service.getListVehicles(
      this.service.paginationList.getPageKey(),
      this.service.paginationList.getPageSize(),
      filters
    ).subscribe(
      (success: []) => {
        if (!this.utils.isDefined(success) || success.length < 1)
          this.service.paginationList.setEnablePagingScroll(false);
        else {
          if (this.service.paginationList.getList().length && concat)
            this.service.paginationList.setList(this.service.paginationList.getList().concat(success));
          else this.service.paginationList.setList(success);

          if (success.length < this.service.paginationList.getPageSize())
            this.service.paginationList.setEnablePagingScroll(false);
          else this.service.paginationList.setEnablePagingScroll(true);
        }
        this.spinner.hide();
      },
      (error) => {
        this.service.paginationList.setList([]);
        this.spinner.hide();
      }
    );
  }

  /**
  * @param {'balance'|'advance'} type is the type of the bank account
  * @description Gets the list of vehicles with the param bank account type, and passes it to "getFileForInscriptionAccount" method
  */
  registerBankAccounts(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicles: this.itemsSelecteds.map(vehicleChecked => {
        const { checked, ...vehicle } = vehicleChecked;
        return vehicle;
      })
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(AccountInscriptionVehicleComponent, dialogConfig);
    dialogRef.afterClosed().toPromise().then(response => {
      if (!response || !response.state) return;
      this.itemsSelecteds = [];
      this.getVehicles();
    });
  }

  /**
  * @description Updates the paginationList variables and executes "getVehicles" method
  */
  onScrollDown() {
    if (this.service.paginationList.getEnablePagingScroll()) {
      this.service.paginationList.setPageKey(
        this.service.paginationList.getPageKey() + 1
      );
      this.getVehicles(this.filters, true);
    }
  }

  /**
  * @description Navigates to vehicles/create
  */
  goToCreate() {
    this.router.navigate(['administration/vehicles/create']);
  }

  getActiveItem(vehicle: Vehicle): SelectableItem {
    const hasPermissionToInscribeAccounts = this.permissionRole.hasPermission(Permission.administration.module, Permission.administration.downloadFileRegistreBank);
    if (!hasPermissionToInscribeAccounts) return { isSelectable: false };
    const hasAdvanceAccount = !!(vehicle && vehicle.bankAccountAdvance);
    const hasBalanceAccount = !!(vehicle && vehicle.bankAccountBalance);
    if (!hasAdvanceAccount && !hasBalanceAccount) return { isSelectable: true, isEnabled: false, errorMessage: 'Este vehículo no tiene cuentas bancarias' };
    const hasAdvanceCreatedInBank = this.utils.getNestedValue(vehicle, 'bankAccountAdvance.createdInBank');
    const hasBalanceCreatedInBank = this.utils.getNestedValue(vehicle, 'bankAccountBalance.createdInBank');
    const hasAdvanceActive = !!this.utils.getNestedValue(vehicle, 'bankAccountAdvance.state.active');
    const hasBalanceActive = !!this.utils.getNestedValue(vehicle, 'bankAccountBalance.state.active');

    if (!hasBalanceAccount && (hasAdvanceCreatedInBank || !hasAdvanceAccount))
      return { isSelectable: true, isEnabled: false, errorMessage: 'Este vehículo no tiene una cuenta bancaria de saldos' };
    if (!hasBalanceActive && (hasAdvanceCreatedInBank || !hasAdvanceAccount))
      return { isSelectable: true, isEnabled: false, errorMessage: 'No se ha aprobado la cuenta bancaria de saldos' };
    if (!hasAdvanceAccount && (hasBalanceCreatedInBank || !hasBalanceAccount))
      return { isSelectable: true, isEnabled: false, errorMessage: 'Este vehículo no tiene una cuenta bancaria de anticipos' };
    if (!hasAdvanceActive && (hasBalanceCreatedInBank || !hasBalanceAccount))
      return { isSelectable: true, isEnabled: false, errorMessage: 'No se ha aprobado la cuenta bancaria de anticipos' };

    return {
      isSelectable: !hasAdvanceCreatedInBank || !hasBalanceCreatedInBank,
      isEnabled: (!hasAdvanceCreatedInBank && hasAdvanceActive) || (!hasBalanceCreatedInBank && hasBalanceActive),
      errorMessage: 'Se requiere la aprobación de las cuentas bancarias'
    };
  }

  /**
  * @param {{ vehicle: Vehicle, selected: boolean }} $event is the vehicle selected from vehicle-item
  * @description If the $event.selected is true makes a push of the vehicle into itemsSelected array, otherwise removes the vehicle from array
  */
  onSelectItem($event: Array<Vehicle>): void {
    this.itemsSelecteds = $event && $event.length ? $event : [];
  }

  /**
  * @description Opens a dialog with the vehicle's conventions
  */
  openConventions(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: true
    };
    dialogConfig.autoFocus = false;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.dialog.open(ConventionsComponent, dialogConfig);
  }

  /**
  * @description Cleans the service's vehicleSelected
  */
  ngOnDestroy(): void {
    this.service.vehicleSelected = null;
  }
}
